import {Fragment, useMemo} from "react";

export const WorkflowProgress = ( {steps = [], currentStep}) => {

    const currentStepIdx = useMemo(() => steps.indexOf(currentStep), [steps, currentStep]);

    return <>
        <div>
            <p>Schritt {currentStepIdx+1} von {steps.length}</p>
            <div className="progress-bar-container">
                {steps.map((step, index) => (
                    <div
                        className={"progress-step "  + (index < currentStepIdx ? 'done' : (currentStepIdx == index ? 'active' : '')) }
                        key={index}>
                        <div className="progress-step-bar-wrapper">
                            <div className="progress-step-bar "></div>
                        </div>
                        <p>{step}</p>
                    </div>))}
            </div>
            <hr></hr>
        </div>
    </>
}